import { API_URL } from '../config';

// Utility function for authenticated fetch requests
export const authenticatedFetch = async (url: string, options: RequestInit = {}) => {
  const accessToken = localStorage.getItem('accessToken');
  
  if (!accessToken) {
    throw new Error('No access token found');
  }

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
    ...options.headers,
  };

  return fetch(url, {
    ...options,
    headers,
  });
};

// Utility function for authenticated fetch with FormData (for file uploads)
export const authenticatedFetchFormData = async (url: string, formData: FormData, options: RequestInit = {}) => {
  const accessToken = localStorage.getItem('accessToken');
  
  if (!accessToken) {
    throw new Error('No access token found');
  }

  const headers = {
    'Authorization': `Bearer ${accessToken}`,
    ...options.headers,
  };

  return fetch(url, {
    ...options,
    method: options.method || 'POST',
    headers,
    body: formData,
  });
};
